


































































































































































































































































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import IRadio from '@/components/icons/IRadio.vue'
import ICheckbox from '@/components/icons/ICheckbox.vue'
import ICheck from '@/components/icons/ICheck.vue'
import IClose from '@/components/icons/IClose.vue'
import IQuestionWhite from '@/components/icons/IQuestionWhite.vue'
import Alert from '@/components/UI/Alert.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Modal from '@/components/UI/Modal.vue';
import SelectNew from '@/components/beta/NewShardList/Filters/SelectNew.vue'
import Router from "@/router";


const locale = namespace('locale')
const workspace = namespace('workspace')
const dialog = namespace('dialog')
const alerts = namespace('alerts')
const mailing = namespace('mailing')

@Component({
  components: {
    SelectNew,
    IRadio,
    ICheckbox,
    ICheck,
    IClose,
    IQuestionWhite,
    Alert,
    Tooltip,
    BtnDefault,
    Modal,
  }
})

export default class EmailConfiguration extends Vue {
  @workspace.Getter('getShow') protected getShow: any
  @locale.Getter('getLocale') protected getLocale: any
  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getPlanStatus') protected getPlanStatus: any
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @alerts.Mutation('setAlert') protected setAlert: any
  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any

  @mailing.Action('sendTestEmail') protected sendTestEmail: any
  @mailing.Action('getMailConfiguration') protected getMailConfiguration: any
  @mailing.Action('saveMailConfiguration') protected saveMailConfiguration: any
  @mailing.Action('deleteMailConfiguration') protected deleteMailConfiguration: any
  @mailing.Action('getStatusMailConfiguration') protected getStatusMailConfiguration: any
  @mailing.Action('getImportListMailConfiguration') protected getImportListMailConfiguration: any
  @mailing.Action('pathConfigMailConfiguration') protected pathConfigMailConfiguration: any


  @mailing.Mutation('status_connect') protected changeStatusConnect: any
  @mailing.Mutation('setSendTestEmail') protected setSendTestEmail: any

  @mailing.Getter('isErrorSendTestEmail') protected isErrorSendTestEmail: any
  @mailing.Getter('loadingPatch') protected loadingPatch: any
  @mailing.Getter('importList') protected importList: any
  @mailing.Getter('loadImportList') protected loadImportList: any
  @mailing.Getter('loading') protected loading: any
  @mailing.Getter('status_connect') protected status_connect: any
  @mailing.Getter('GetShowMailConfiguration') protected GetShowMailConfiguration: any
  @mailing.Getter('loadingSendTest') protected loadingSendTest: any
  @mailing.Getter('loadingDeleteConnection') protected loadingDeleteConnection: any

  lang: any = "ru"

  get languages() {
    return [

      {id: 'en', text: "English"},
      {id: 'de', text: "Deutsch"},
      {id: 'ru', text: "Русский"},
    ]
  }

  destroyed() {
    this.changeStatusConnect(null)
    this.selectedImportMail = ''
  }


  async stopMailing() {
    this.mailingOptions.isMailingEnabled = false
    await this.changeLang()

  }

  changeConfig(val: boolean) {
    if (!val) {
      if (Boolean(this.GetShowMailConfiguration)) {
        this.isShowDeleteConnectionModal = true
      } else {
        this.send_leadfrog = val
      }
    } else {
      this.send_leadfrog = val
    }
    if (!this.mailingOptions.isMailingEnabled) {
      this.mailingOptions.isMailingEnabled = true
      this.changeLang()
    }

  }

  send_leadfrog: boolean = false
  use_other_mail: boolean = false

  mailingOptions: any = {
    isMailingEnabled: true,
    lang: ''
  }

  emailConfiguration: any = {
    id: null,
    userName: '',
    password: '',
    otherMail: '',
    // imapServer: '',
    // imapPort: 0,
    smtpServer: '',
    smtpPort: '',
    lang: this.$i18n.locale
  }

  showImport: boolean = false
  mailList: any = []
  selectedImportMail: string = ''
  isErrorsEmpty: any = {
    userName: false,
    password: false,
    otherMail: false,
    // imapServer: false,
    // imapPort: false,
    smtpServer: false,
    smtpPort: false
  }
  isErrorsValid: any = {
    userName: false,
    otherMail: false,
    // imapServer: false,
    // imapPort: false,
    smtpServer: false,
    smtpPort: false
  }
  isError: boolean = false
  // status_connect: string = ''
  isShowDeleteConnectionModal: boolean = false

  isShowSendTestModal: boolean = false
  test_email: string = ''
  isErrorTestEmaiServer: string = ''
  isErrorTestEmail: any = {
    empty: false,
    valid: false
  }
  // loadingSendTest: boolean = false
  isShowAlert: boolean = false
  isFirstLoading: boolean = false

  closeTestMail() {
    this.isShowSendTestModal = false
    this.setSendTestEmail(false)
    this.isErrorTestEmail = {
      empty: false,
      valid: false
    }
    this.test_email = ''
  }

  get headers() {
    return [
      {text: '', value: 'select', sortable: false, width: '44'},
      {text: this.$t('mailing.config.import.email'), value: 'email', sortable: false},
      {text: this.$t('mailing.config.import.exhibition'), value: 'show', sortable: false},
    ]
  }

  @Watch('GetShowMailConfiguration')
  setConfig(val: any) {
    if (val) {
      this.emailConfiguration = {
        id: val.id,
        userName: val.userName,
        password: val.password,
        otherMail: val.otherMail,
        // imapServer: val.imapServer,
        // imapPort: val.imapPort,
        smtpServer: val.smtpServer,
        smtpPort: val.smtpPort
      }

      this.use_other_mail = !!val.otherMail;
    } else {
      this.emailConfiguration = {
        id: null,
        userName: '',
        password: '',
        otherMail: '',
        // imapServer: '',
        // imapPort: '',
        smtpServer: '',
        smtpPort: ''
      }
      this.use_other_mail = false
    }
  }

  async getStatusConfig(val:string) {
    await this.getStatusMailConfiguration(
        {
          params: {
            idPartisipation: this.getCurrentExhibition.companyParticipation._id
          }
        })
  }

  @Watch('getCurrentExhibition')
  async getCompany() {
    if (this.getCurrentExhibition) {
      await this.getMailConfiguration(this.getCurrentExhibition.companyParticipation._id)
      this.send_leadfrog = Boolean(this.GetShowMailConfiguration)
      if (this.emailConfiguration.id) {
        this.getStatusConfig(this.getCurrentExhibition.companyParticipation._id)
      }
      this.mailingOptions = this.getCurrentExhibition.companyParticipation.options.mailing
    }
  }

  mounted() {
    if (this.getCurrentExhibition && this.getCurrentExhibition.companyParticipation) this.getCompany()

  }

  checkConnection() {
    this.saveMailConfiguration({
      params: {
        idPartisipation: this.getCurrentExhibition.companyParticipation._id
      },
      body:
      this.emailConfiguration
    })
  }

  checkConfigData() {
    this.isErrorsEmpty.userName = this.emailConfiguration.userName == ''
    this.isErrorsEmpty.password = this.emailConfiguration.password == ''
    this.isErrorsEmpty.smtpServer = this.emailConfiguration.smtpServer == ''
    this.isErrorsEmpty.smtpPort = this.emailConfiguration.smtpPort == ''

    this.isErrorsEmpty.otherMail = this.use_other_mail ? this.emailConfiguration.otherMail == '' && this.emailConfiguration.otherMail : false

    let flag = false

    for (let key in this.isErrorsEmpty) {
      if (this.isErrorsEmpty[key]) {
        flag = true
        this.isError = true
      }
    }

    this.isErrorsValid.smtpServer = !this.isErrorsEmpty.smtpServer && !this.validUrl(this.emailConfiguration.smtpServer)
    this.isErrorsValid.smtpPort = !this.isErrorsEmpty.smtpPort && !this.validNumber(this.emailConfiguration.smtpPort)

    this.isErrorsValid.otherMail = this.use_other_mail ? !this.emailConfiguration.otherMail && !this.validEmail(this.emailConfiguration.otherMail) : false

    for (let key in this.isErrorsValid) {
      if (this.isErrorsValid[key]) flag = true
    }

    return !flag;


  }

  async changeLang() {
    await this.pathConfigMailConfiguration({
      params: {
        idPartisipation: this.getCurrentExhibition.companyParticipation._id
      },
      body: {
        options: {
          mailing: this.mailingOptions
        }
      }
    })
  }

  save() {
    this.isError = false

    if (this.checkConfigData()) {
      this.checkConnection()
    }
  }

  async sendTest() {
    try {
      const data = await this.sendTestEmail({
        params: {
          idPartisipation: this.getCurrentExhibition.companyParticipation._id
        },
        body: {
          email: this.test_email
        }
      })
      if (data) {
        this.closeTestMail()
      }
    } catch (e) {
      this.isShowSendTestModal = true
    }

  }

  openModalImport() {
    this.showImport = true
    this.getImportListMailConfiguration({
      params: {
        companyCode: this.$route.params.code
      },
      showCode: this.$route.params.showCode
    })
  }

  selectImportMail() {
    this.showImport = false
    const importItem = this.importList.filter((el: any) => el.id == this.selectedImportMail)[0]
    this.emailConfiguration = {...importItem, id: null}
    this.changeStatusConnect(null)
    this.isError = false
    this.isErrorsValid = {
      userName: false,
      otherMail: false,
      // imapServer: false,
      // imapPort: false,
      smtpServer: false,
      smtpPort: false
    }
  }

  toMailing() {
    Router.push({
      name: 'MailingList',
      params: {
        code: this.$route.params.code,
        showCode: this.$route.params.showCode
      }
    }).catch(() => {
    })
  }

  async deleteConnection() {
    if (this.emailConfiguration.id) {
      await this.deleteMailConfiguration(
          this.emailConfiguration.id
      )
    }
    this.isShowDeleteConnectionModal = false
    this.send_leadfrog = false

  }

  checkSendTest() {
    this.isErrorTestEmail.empty = this.test_email == ''
    if (this.isErrorTestEmail.empty) return
    this.isErrorTestEmail.valid = !this.validEmail(this.test_email)
    if (this.isErrorTestEmail.valid) return
    this.sendTest()
  }

  validEmail(email: string) {
    let re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    return re.test(email)
  }

  validUrl(url: string) {
    // let re = /^(ftp|http|https):\/\/[^ "]+$/
    // return re.test(url)
    return true
  }

  validNumber(str: string) {
    let re = /^\d+$/
    return re.test(str)
  }

  closeAlert() {
    this.isShowAlert = false
  }

  showPlans() {
    this.SetFullPlanShow(true)
  }

}
